<template>
  <v-app>
    <bugreport-dialog :is-visible.sync="bugreportDialog" @submit="openSnackBar">
    </bugreport-dialog>
    <v-row>
      <snackbar
        v-model="snackbar"
        :snackbar="snackbar"
        :snackbar-data="snackbarData"
        @submit="openSnackBar"
      >
      </snackbar>
    </v-row>
  </v-app>
</template>

<script>
// Components
import BugreportDialog from "@/components/common-components/BugreportDialog/BugreportDialog";
import Snackbar from "@/components/Snackbar";

// Libs
import isEmpty from "lodash/isEmpty";

export default {
  name: "WidgetNewsletter",
  components: {
    BugreportDialog,
    Snackbar
  },
  data() {
    return {
      initialDataWidgets: window.initialDataWidgets || {},
      bugreportDialog: false,
      snackbar: false,
      snackbarData: undefined
    };
  },
  methods: {
    openSnackBar(data) {
      this.snackbar = true;
      this.snackbarData = data;
    }
  },
  created() {
    if (!isEmpty(this.initialDataWidgets)) {
      this.$store.dispatch("setMess", this.initialDataWidgets.mess);
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/common-widgets";
</style>
